import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Map } from 'lucide-react';
interface MapModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function MapModal({
  isOpen,
  onClose
}: MapModalProps) {
  return <AnimatePresence data-id="element-28">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="absolute inset-0 z-50 flex flex-col bg-slate-900/60 backdrop-blur-md" data-id="element-29">
          <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="mt-auto h-[85%] bg-white rounded-t-3xl shadow-2xl flex flex-col overflow-hidden" data-id="element-30">
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100 bg-white z-10" data-id="element-31">
              <div className="flex items-center gap-2" data-id="element-32">
                <div className="w-8 h-8 rounded-full bg-minerva-blue/10 flex items-center justify-center" data-id="element-33">
                  <Map size={16} className="text-minerva-blue" data-id="element-34" />
                </div>
                <div data-id="element-35">
                  <h3 className="text-sm font-bold text-slate-900" data-id="element-36">
                    SNMMI Floorplan
                  </h3>
                  <p className="text-[11px] font-medium text-slate-500" data-id="element-37">
                    Find us at Booth #1762
                  </p>
                </div>
              </div>
              <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-100 text-slate-500 hover:bg-slate-200 transition-colors" data-id="element-38">
                <X size={18} data-id="element-39" />
              </button>
            </div>

            {/* Map Container (Scrollable) */}
            <div className="flex-1 overflow-auto bg-slate-50 p-4" data-id="element-40">
              <div className="min-w-[600px] sm:min-w-[800px] relative" data-id="element-41">
                <img src="https://cdn.magicpatterns.com/uploads/gJ5pSqwjE1mT9ZXPJjeS3A/Screenshot_2026-05-12_at_13.25.24.png" alt="SNMMI Floorplan" className="w-full h-auto rounded-xl shadow-sm border border-slate-200" data-id="element-42" />
              </div>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}